import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function StyledPatchFavoriteButton({ children }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: "-12px",
        right: "-12px",
        backgroundColor: theme.palette.background.inverted,
        color: theme.palette.text.inverted,
        fontSize: "14px",
        fontWeight: "700",
        height: "24px",
        width: "24px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "2px",
        [theme.breakpoints.down("laptop")]: {
          width: "17px",
          height: "17px",
          right: "-2px",
          bottom: "-4px",
          fontSize: "11px",
          paddingTop: "4px",
        },
      }}
    >
      {children}
    </Box>
  );
}

export default React.memo(StyledPatchFavoriteButton);
